import type { Timestamp } from 'firebase/firestore'

export interface FirestoreDocument {
  id?: string
  created_at?: Date | Timestamp
  updated_at?: Date | Timestamp
}

export class FirestoreError extends Error {
  constructor(
    message: string,
    public code: string,
    public originalError?: unknown
  ) {
    super(message)
    this.name = 'FirestoreError'
  }
}
